// Centralized labels for backend-authored program descriptors. Keeping the
// known name keys explicit makes them discoverable by the locale harvest and
// prevents system copy embedded in API records from bypassing i18n.
export function learningProgramTypeLabel(programType, t) {
  switch (programType) {
    case 'public_cohort':
      return t('learningProgram.types.publicCohort', 'Public cohort');
    case 'institution_cohort':
      return t('learningProgram.types.institutionCohort', 'Institution cohort');
    case 'institution_self_paced':
      return t('learningProgram.types.institutionSelfPaced', 'Institution self-paced');
    case 'personal_semester':
      return t('learningProgram.types.personalSemester', 'Personal semester');
    default:
      return t('learningProgram.types.personalSelfPaced', 'Self-paced');
  }
}

export function learningProgramSystemLabel(program, t) {
  switch (program?.nameKey) {
    case 'learningPrograms.personalSelfPaced':
      return t('learningPrograms.personalSelfPaced', 'Personal self-paced');
    case 'learningPrograms.publicCohort':
      return t('learningPrograms.publicCohort', 'Lingo Booth cohort');
    case 'learningPrograms.institutionCohort':
      return t('learningPrograms.institutionCohort', 'Institution cohort');
    case 'learningPrograms.institutionSelfPaced':
      return t('learningPrograms.institutionSelfPaced', 'Institution self-paced');
    case 'learningPrograms.personalSemester':
      return t('learningPrograms.personalSemester', 'Personal semester');
    default:
      return learningProgramTypeLabel(program?.programType, t);
  }
}
